import * as fortem from './clients/fortem'
import * as breathe from './clients/breathe'

const content = { fortem, breathe }

export default content[(process.env.REACT_APP_REALM || '') as keyof typeof content]
